import React from 'react'
import { KIND } from 'baseui/button'
import { useTranslation } from 'react-i18next'
import ButtonCustom from '@/components/ButtonCustom'
import { SizeButton } from '@/constants/sizeButton'
import { lightTheme } from '@/customTheme'
import Icons from '../../../Icons'

const TRANSFORM_ITEMS = [
  { name: 'Flip', Icon: Icons.FlipH, direction: 'horizontal' },
  { name: 'Mirror', Icon: Icons.FlipV, direction: 'vertical' },
] as const

export interface TransformButtonsProps {
  style?: React.CSSProperties
  onFlipHorizontal: () => void
  onFlipVertical: () => void
}

/**
 * Pure Transform section (Flip / Mirror tiles). No editor context — the editor's
 * `Transform` and Batch crop each supply their own flip handlers.
 */
function TransformButtons({ style, onFlipHorizontal, onFlipVertical }: TransformButtonsProps) {
  const { t } = useTranslation()
  return (
    <div style={{ width: '300px', paddingRight: '8px', marginRight: '16px', ...style }} className="mt-50">
      <div
        style={{
          width: '292px',
          height: '26px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '8px',
        }}
      >
        <span style={{ ...lightTheme.typography.Small14Semibold, color:lightTheme.colors.text.text_black_title, textTransform: 'capitalize' }}>{t('Transform')}</span>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', columnGap: '8px', width: '292px', rowGap: '20px' }}>
        {TRANSFORM_ITEMS.map(({ name, Icon, direction }) => (
          <div key={name}>
            <ButtonCustom
              type={SizeButton.LARGE}
              kind={KIND.tertiary}
              onClick={direction === 'horizontal' ? onFlipHorizontal : onFlipVertical}
              style={{ width: '67px', position: 'relative' }}
            >
              <Icon size={24} />
            </ButtonCustom>
            <p
              style={{
                textAlign: 'center',
                fontSize: lightTheme.typography.Small11medium.fontSize,
                fontWeight: lightTheme.typography.Small11medium.fontWeight,
                lineHeight: lightTheme.typography.Small11medium.lineHeight,
                color: lightTheme.colors.grayScale600,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                marginTop: '8px',
              }}
            >
              {t(name)}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TransformButtons
